import '@angular/compiler';
import { PageLoginComponent } from './page.login/page.login.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { ComponentChatComponent } from './component.chat/component.chat.component';
import { PortalSeasonPagenationComponent } from './portal.season.pagenation/portal.season.pagenation.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonViewerTreeComponent } from './portal.season.viewer.tree/portal.season.viewer.tree.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PageTestComponent } from './page.test/page.test.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PageAdminDashboardComponent } from './page.admin.dashboard/page.admin.dashboard.component';
import { PortalSeasonLoadingHexaComponent } from './portal.season.loading.hexa/portal.season.loading.hexa.component';
import { PortalSeasonStatusbarComponent } from './portal.season.statusbar/portal.season.statusbar.component';
import { ComponentLoadingComponent } from './component.loading/component.loading.component';
import { PageAdminSettingsComponent } from './page.admin.settings/page.admin.settings.component';
import { PortalSeasonLoadingComponent } from './portal.season.loading/portal.season.loading.component';
import { PortalSeasonTabComponent } from './portal.season.tab/portal.season.tab.component';
import { PortalSeasonAlertComponent } from './portal.season.alert/portal.season.alert.component';
import { PortalSeasonUiDropdownComponent } from './portal.season.ui.dropdown/portal.season.ui.dropdown.component';
import { ComponentAdminsidebarComponent } from './component.adminsidebar/component.adminsidebar.component';
import { PageAdminLogComponent } from './page.admin.log/page.admin.log.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
    declarations: [
        AppComponent,
        PageLoginComponent,
        PortalSeasonLoadingSeasonComponent,
        ComponentChatComponent,
        PortalSeasonPagenationComponent,
        LayoutEmptyComponent,
        PortalSeasonViewerTreeComponent,
        PageMainComponent,
        PageTestComponent,
        LayoutAdminComponent,
        PageAdminDashboardComponent,
        PortalSeasonLoadingHexaComponent,
        PortalSeasonStatusbarComponent,
        ComponentLoadingComponent,
        PageAdminSettingsComponent,
        PortalSeasonLoadingComponent,
        PortalSeasonTabComponent,
        PortalSeasonAlertComponent,
        PortalSeasonUiDropdownComponent,
        ComponentAdminsidebarComponent,
        PageAdminLogComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule { }